import type { CustomerAddress } from "@/api/endpoints/address";
import type { Location as MasterLocation } from "@/api/endpoints/locations";

export interface AddressFormState {
  houseNo: string;
  village: string;
  moo: string;
  road: string;
  soi: string;
  province: string;
  district: string;
  subdistrict: string;
  postcode: string; 
  locationID: string;
  phone: string;
}

export const EMPTY_ADDRESS_FORM: AddressFormState = {
  houseNo: "",
  village: "",
  moo: "",
  road: "",
  soi: "",
  province: "",
  district: "",
  subdistrict: "",
  postcode: "",
  locationID: "",
  phone: "",
};

/** Writes a picked master location over the read-only half of the form. */
export function applyLocation(
  form: AddressFormState,
  master: MasterLocation,
): AddressFormState {
  return {
    ...form,
    province: master.province,
    district: master.district,
    subdistrict: master.subdistrict,
    postcode: master.postCode,
    locationID: master.locationID,
  };
}

/**
 * The address to submit: everything the form owns, laid over the address being
 * replaced so the fields it never shows (accountNo, sequenceNo, houseStatusID)
 * survive. locationID belongs to the form now — spreading `current` alone would
 * ship the old address's key alongside the new province.
 */
export function buildNextAddress(
  current: CustomerAddress,
  form: AddressFormState,
): CustomerAddress {
  return {
    ...current,
    addressNo: form.houseNo.trim(),
    villageName: form.village.trim(),
    mooNo: form.moo.trim(),
    soiName: form.soi.trim(),
    roadName: form.road.trim(),
    province: form.province,
    district: form.district,
    subdistrict: form.subdistrict,
    postCode: form.postcode,
    locationID: form.locationID,
    phone: [{ type: "Mobile", number: form.phone }],
  };
}
